import classNames from "classnames";
import {MultiSelect} from "primereact/multiselect";
import {Fragment} from "react";
import {SplitButton} from "primereact/splitbutton";
import Icon from "./../Icon";
import {DataTable} from "primereact/datatable";
import React from "react";
import {BodyCell} from "primereact/components/datatable/BodyCell";

export default (props) => {
    const rowGroupHeaderTemplate = props.rowGroupMode && !props.rowGroupHeaderTemplate ? () => null : props.rowGroupHeaderTemplate;
    return <div className="table-responsive">
            <DataTable
                rowGroupMode={props.rowGroupMode}
                groupField={props.groupField}
                rowGroupHeaderTemplate={rowGroupHeaderTemplate}
                rowGroupFooterTemplate={props.rowGroupMode && !props.rowGroupFooterTemplate ? () => null : (props.rowGroupFooterTemplate ? (row, index) => {
                    // TODO ez a szar csak egy tr-t tesz ki a footer-be...
                    const f = props.rowGroupMode && !props.rowGroupFooterTemplate ? () => null : props.rowGroupFooterTemplate;

                    const groupHeaderValue = rowGroupHeaderTemplate(row);
                    row = (props.groupAggregationRows || []).find((row) => rowGroupHeaderTemplate(row) === groupHeaderValue);
                    if (!row) return null;

                    const columns = React.Children.toArray(props.children);
                    let hasRowSpanGrouping = props.rowGroupMode === 'rowspan';
                    let cells = [];

                    for(let i = 0; i < columns.length; i++) {
                        let column = columns[i];
                        let rowSpan;
                        if(hasRowSpanGrouping) {
                            if(props.sortField === column.props.field) {
                                if(props.groupRowSpan)
                                    rowSpan = props.groupRowSpan;
                                else
                                    continue;
                            }
                        }

                        let cell = <BodyCell key={i} {...column.props} value={props.value} rowSpan={rowSpan} rowData={row} rowIndex={index} />;

                        cells.push(cell);
                    }

                    return cells;
                    //return <td colSpan={React.Children.count(props.children)}>{!!f && f(row, index)}</td>;
                } : null)}
                value={props.value}
                onRowDoubleClick={props.onRowDoubleClick}
                rowClassName={props.rowClassName}
                onRowReorder={props.onRowReorder}

                first={props.paging.first}
                className={classNames("table table-hover", {disabled: props.disabled})}
                onPage={props.onPage}
                virtualScroll={props.virtualScroll || false}
                virtualRowHeight={props.virtualRowHeight || 30}
                scrollHeight={props.scrollHeight || "200px"}
                onVirtualScroll={props.onVirtualScroll}
                scrollable={props.scrollable || false}
                resizableColumns={props.resizableColumns !== undefined ? props.resizableColumns : true}

                loading={props.loading}

                footerColumnGroup={props.footerColumnGroup}
                headerColumnGroup={props.headerColumnGroup}

                paginator={props.paginator}
                lazy={true}
                rows={props.rows}
                rowsPerPageOptions={props.rowsPerPageOptions}
                totalRecords={props.totalRecords || 0}
                selectionMode={props.selectionMode || "single"}
                metaKeySelection={props.metaKeySelection || false}
                onSort={props.onSort}
                sortField={props.sortField}
                sortOrder={props.sortOrder}
                selection={props.selection}
                emptyMessage={props.emptyMessage}
                onSelectionChange={props.onSelectionChange}
                paginatorTemplate={props.paginatorTemplate}
                currentPageReportTemplate={props.currentPageReportTemplate}
                paginatorLeft={
                    <Fragment>
                        {props.actions && props.showVisibleColumnFilter ? <MultiSelect
                            disabled={props.loading}
                            selectedItemTemplate={() => <i className="p-selected-icon fa fa-th-list"/>}
                            value={props.visibleColumns}
                            options={props.possibleVisibleColumns}
                            onChange={(e) => {
                                let v = e.value;
                                v.length !== 0 && props.setPersistenceState({visibleColumns: v}, () => props.loadData(props.paging));
                            }}
                        /> : null}
                        {props.actions && props.showVisibleColumnFilter ? props.paginatorLeft : null}
                    </Fragment>
                }
                paginatorRight={props.actions && <Fragment>
                    {props.paginatorRight}
                    {props.exportModel.length ? <SplitButton disabled={props.loading} {...props.exportModel[0]} onClick={props.exportModel[0].command} model={props.exportModel}
                                 className="p-button-secondary"/> : null}
                    <button onClick={() => props.loadData(true)} type="button"
                            className={classNames("btn btn-default", {disabled: props.loading})}
                            disabled={props.loading}><Icon lib="fa" name="refresh" spin={props.loading} />
                    </button>
                </Fragment>}
            >
            {props.children}
        </DataTable>
    </div>;
}